/* DeviceStatusComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./DeviceStatusRenderer");

class DeviceStatusComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._context = context;
        this._gameEditor = context.gameEditor;
        this._osPlanDetailsViewModel = context.osPlanDetailsViewModel;
        this._plan = this._gameEditor.getPlan();
        this._statuses = this._plan.getDeviceUpgradeStatuses() || [];
        this._upgradeStatusVal = this._statuses[this._value];
        this._upgradeStatus =
            typeof this._upgradeStatusVal === "object"
                ? this._upgradeStatusVal.status
                : this._upgradeStatusVal;
        this._upgradeStatusTitle = this._getStatusTitle(this._value);
        this._renderer = new Renderer(this);
        this._registerPlanListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    // DefaultColumnComponent's constructor calls this._registerListeners() from inside
    // super(value), before any field below is assigned — must stay a no-op.
    _registerListeners() {
        // Component listeners managed by renderer
    }

    _unregisterListeners() {
        // Component listeners managed by renderer
    }

    _registerPlanListeners() {
        this._osPlanDetailsViewModel.on(
            "DeviceUpgradeStatusesChanged",
            (this._onDeviceUpgradeStatusesChanged = this._onDeviceUpgradeStatusesChanged.bind(this))
        );
    }

    _unregisterPlanListeners() {
        this._osPlanDetailsViewModel.removeListener(
            "DeviceUpgradeStatusesChanged",
            this._onDeviceUpgradeStatusesChanged
        );
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    getPlan() {
        return this._plan;
    }

    shutdown() {
        // Unregister listeners synchronously to prevent memory leaks during grid recycling
        this._unregisterPlanListeners();

        // Renderer shutdown can happen asynchronously
        const shutdownPromise = this._renderer ? this._renderer._shutdown() : Promise.resolve();

        return shutdownPromise.then(() => {
            this._renderer = undefined;
            this._value = undefined;
            this._plan = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _onDeviceUpgradeStatusesChanged() {
        this._statuses = this._plan.getDeviceUpgradeStatuses() || [];
        this.setDeviceStatus(this._value);
    }

    _getStatusTitle() {
        if (typeof this._upgradeStatusVal === "object") {
            const parts = [`Status: ${this._upgradeStatusVal.status}`];

            if (this._upgradeStatusVal.comment) {
                parts.push(`Comment: ${this._upgradeStatusVal.comment}`);
            }

            if (this._upgradeStatusVal.userName) {
                parts.push(`Author: ${this._upgradeStatusVal.userName}`);
            }

            return parts.join("\n");
        }

        return `Status: ${this._upgradeStatusVal}`;
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this._value = newVal;
            this.setDeviceStatus(newVal);
        }
    }

    getValue() {
        return this.getDeviceStatus();
    }

    setDeviceStatus(newVal) {
        this._upgradeStatusVal = this._statuses[newVal];
        this._upgradeStatus =
            typeof this._upgradeStatusVal === "object"
                ? this._upgradeStatusVal.status
                : this._upgradeStatusVal;
        this._upgradeStatusTitle = this._getStatusTitle();
        this.emit("DeviceStatus", this._upgradeStatus, this._upgradeStatusTitle);
        return this;
    }

    getDeviceStatus() {
        return this._upgradeStatus;
    }

    getDeviceStatusTitle() {
        return this._upgradeStatusTitle;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DeviceStatusComponent;
